export {ActivitiesModule} from './core/activities.module';
export {LessonsModule} from './core/lessons/lessons.module';
export {LessonsService} from './core/lessons/services/lessons.service';
export {ThemesModule} from './core/themes/themes.module';
export {ServicesInstantiatorService as ActivitiesServicesInstantiatorService} from './core/services/services-instantiator.service';
